import { AgreementDetails } from "features/types";
import { useQuery } from "@tanstack/react-query";
import { get } from "services/http";

export type AgreementVisibility = "REGISTRATION" | "LOGIN" | "ACCOUNT_PAGE" | "AUTO_RENEWAL";

export const fetchAgreements = (
  visibility: AgreementVisibility,
  planPackageId?: number,
  billingInterval?: string,
) => {
  const params = new URLSearchParams();
  if (planPackageId != null) params.set("planPackageId", String(planPackageId));
  if (billingInterval != null) params.set("billingInterval", billingInterval);
  const query = params.toString();
  return get({
    url: `/agreements/find/${visibility}${query ? `?${query}` : ""}`,
  }) as Promise<Array<AgreementDetails>>;
};

export const useFetchAgreementsQuery = (
  visibility: AgreementVisibility,
  planPackageId?: number,
  billingInterval?: string,
) => {
  return useQuery(
    ["fetchAgreements", visibility, planPackageId, billingInterval],
    () => fetchAgreements(visibility, planPackageId, billingInterval),
    {
      staleTime: Infinity,
      enabled: visibility !== "AUTO_RENEWAL" || planPackageId != null,
    }
  );
};
